<template>
    <div>
      Design 
    </div>
</template>
<script>

  export default {
    name: "Design",
    data() {
      return {
      }
    },
    methods: {
    },
    mounted() {
    }
  };
</script>
<style>
/* .header-class {
  padding-top: 110px !important;
} */
</style>
